import { openDB } from 'idb';

const DB_NAME = 'journal_db';
const STORE_NAME = 'blocks';

let dbPromise = null;

export function initDB() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: 'id' });
        }
      },
    });
  }
  return dbPromise;
}

export async function saveBlocks(blocks) {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  for (const block of blocks) {
    tx.store.put(block);
  }
  await tx.done;
}

export async function saveBlock(block) {
  const db = await initDB();
  await db.put(STORE_NAME, block);
}

export async function getAllBlocks() {
  const db = await initDB();
  // Return sorted by created_at DESC to mimic backend
  const all = await db.getAll(STORE_NAME);
  return all.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
}

export async function deleteBlockLocal(id) {
  const db = await initDB();
  await db.delete(STORE_NAME, id);
}

export async function clearDB() {
  const db = await initDB();
  await db.clear(STORE_NAME);
}
